import React, { useState } from "react";
import { Box, Toolbar, Typography, Badge } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";

import { styled, useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { NotificationsActive as NotificationsActiveIcon } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setDrawer } from "../../../app/slices/appSlice";
import ProfileMenu from "./ProfileMenu";
import ReminderPopover from "./ReminderPopover";

const Appbar = ({ reminders = [], reminderCount = 0, onRefetchReminders }) => {
  const [reminderOpen, setReminderOpen] = useState(false);
  const [reminderAnchorPosition, setReminderAnchorPosition] = useState(null);

  const drawerWidth = 210;
  const theme = useTheme();

  const leftDrawerOpened = useSelector((state) => state.app.is_drawer_opened);
  const dispatch = useDispatch();

  const handleReminderClick = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setReminderAnchorPosition({
      top: rect.bottom,
      left: rect.right,
    });
    setReminderOpen(true);
  };

  const handleReminderClose = () => {
    setReminderOpen(false);
  };

  const handleReminderDeleted = () => {
    if (onRefetchReminders) {
      onRefetchReminders();
    }
  };

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    }),
  }));

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        elevation={0}
        open={leftDrawerOpened}
        sx={{
          bgcolor: theme.palette.primary.main,
        }}
      >
        <Toolbar>
          <IconButton
            onClick={() => dispatch(setDrawer())}
            color="inherit"
            aria-label="open drawer"
            edge="start"
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h5"
            component="div"
            sx={{ flexGrow: 1, fontSize: { xs: "1rem", sm: "1.5rem" } }}
          >
            Ticketing System
          </Typography>
          <IconButton
            color="inherit"
            onClick={handleReminderClick}
            sx={{ mr: 1 }}
          >
            <Badge badgeContent={reminderCount} color="error">
              <NotificationsActiveIcon />
            </Badge>
          </IconButton>
          <ProfileMenu />
        </Toolbar>
      </AppBar>
      <ReminderPopover
        anchorPosition={reminderAnchorPosition}
        open={reminderOpen}
        onClose={handleReminderClose}
        reminders={reminders}
        onReminderDeleted={handleReminderDeleted}
      />
    </Box>
  );
};

export default Appbar;
